import { FC, useState } from 'react';
import { Typography, Collapse } from '@mui/material';
import { useThemeContext } from './ThemeContext';
import useTranslations from './translation/hooks/translation';

interface Props {
  paragraphs: string[];
}

const Paragraphs: FC<Props> = ({ paragraphs }) => {
  const { darkMode } = useThemeContext();
  const [open, setOpen] = useState(false);
  const { currentLanguage } = useTranslations();

  const readMore = currentLanguage === 'pl' ? 'Czytaj więcej' : 'Read more';
  const readLess = currentLanguage === 'pl' ? 'Czytaj mniej' : 'Read less';

  if (paragraphs.length <= 1) {
    return (
      <Typography variant="subtitle2" fontWeight={300} color={darkMode ? '#FFF' : '#000'} textAlign="justify" paragraph>
        {paragraphs[0]}
      </Typography>
    );
  }

  return (
    <div>
      <Typography variant="subtitle2" fontWeight={300} color={darkMode ? '#FFF' : '#000'} textAlign="justify" paragraph style={{ marginBottom: '1em' }}>
        {paragraphs[0]}
      </Typography>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {paragraphs.slice(1).map((para, index) => (
          <Typography
            key={index}
            variant="subtitle2"
            fontWeight={300}
            color={darkMode ? '#FFF' : '#000'}
            textAlign="justify"
            paragraph
            style={{ marginBottom: index !== paragraphs.length - 2 ? '1em' : '0' }}
          >
            {para}
          </Typography>
        ))}
      </Collapse>
      <div style={{ textAlign: 'right', marginTop: open ? 0 : '-0.5em' }}>
        <span
          style={{
            cursor: 'pointer',
            color: darkMode ? '#90caf9' : '#1976d2',
            fontWeight: 500,
            fontSize: '0.95em',
            userSelect: 'none',
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? readLess : readMore}
        </span>
      </div>
    </div>
  );
};

export default Paragraphs;
